import { InputType } from 'config'
import { FormTableHeader } from 'stories/components'

export const interestHeader: FormTableHeader[] = [
  { key: 'reference', title: 'Reference' },
  { key: 'fromWhom', title: 'From Whom Received/Paid' },
  { key: 'payment', title: 'Payment' },
  { key: 'deposit', title: 'Deposit' },
  { key: 'balance', title: 'Balance' },
  { key: 'date', title: 'Date' },
]

export const interestDefaultInputs = (): Record<string, InputType> => {
  return {
    date: {
      inputType: 'text',
      type: 'date',
      title: 'Date',
      value: '',
      error: '',
      required: true,
    },
    reference: {
      inputType: 'text',
      type: 'text',
      title: 'Reference',
      value: '',
      error: '',
      required: true,
    },
    fromWhom: {
      inputType: 'text',
      type: 'text',
      title: 'From Whom Received/Paid',
      value: '',
      error: '',
      required: true,
    },
    payment: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Payment',
      prefix: '$',
      value: '',
      error: '',
      required: true,
    },
    deposit: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Deposit',
      prefix: '$',
      value: '',
      error: '',
      required: true,
    },
  }
}
